import { render } from "./PartForm.vue?vue&type=template&id=f3b5449a"
import script from "./PartForm.vue?vue&type=script&lang=js"
export * from "./PartForm.vue?vue&type=script&lang=js"

import "./PartForm.vue?vue&type=style&index=0&id=f3b5449a&lang=sass"

import exportComponent from "/opt/build/repo/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__